/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Tab, Tabs } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import * as Redux from 'react-redux';
import {
  CustomTabPanel,
  a11yProps,
} from '../../materias/components/AsignarCarreras';
import {
  asistenciasByHorarios,
  notasByBloquesPedagogicos,
} from '../BoletinesHelper';
import { ASISTENCIAS_BOLETINES, BOLETIN_BOLETINES } from '../BoletinesReducer';
import PlanesEvaluacionesNotas from './PlanesEvaluacionesNotas';

const BoletinComponent = ({ data }) => {
  const dispatch = Redux.useDispatch();

  const bloquesPedagogicosStore = Redux.useSelector(
    (state) => state.bloquesPedagogicos,
  );
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const horariosStore = Redux.useSelector((state) => state.horarios);

  const [materias, setMaterias] = React.useState([]);
  const [asistencias, setAsistencias] = React.useState();

  const [tab, setTab] = React.useState(0);
  const tabHanlder = (event, newValue) => setTab(newValue);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const msteriasArray = notasByBloquesPedagogicos(
          bloquesPedagogicosStore.all,
          planEvaluacionStore.all,
          data.notasEvaluativas,
          data.actividadesExtras,
        );

        setMaterias(msteriasArray);
        dispatch({ type: BOLETIN_BOLETINES, payload: msteriasArray });

        const estadisticas = asistenciasByHorarios(
          bloquesPedagogicosStore.all,
          planEvaluacionStore.all,
          horariosStore.all,
          data.asistenciasDiarias,
        );

        setAsistencias(estadisticas);
        dispatch({ type: ASISTENCIAS_BOLETINES, payload: estadisticas });
      } catch (error) {
        console.error('Error en el efecto:', error.message);
      }
    };

    fetchData();
  }, []);

  const boleta = (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>ÁREAS DE FORMACIÓN</strong>
            </TableCell>
            {bloquesPedagogicosStore.all.map((blo) => {
              return (
                <TableCell key={`blo_${blo.id}`} align="center">
                  {blo.abrev}
                </TableCell>
              );
            })}
            <TableCell align="center">
              <strong>DEF.</strong>
            </TableCell>
            <TableCell align="center">
              <strong>INAS.</strong>
            </TableCell>
            <TableCell align="center">
              <strong>ASIS.</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {materias.map((el) => {
            const asistencia = asistencias.find((as) => as.id === el.id);
            return (
              <TableRow key={`materias-${el.id}`}>
                <TableCell key={`materia_${el.id}`}>{el.nombre}</TableCell>
                {el.bloques.map((bloque) => {
                  return (
                    <TableCell key={`bloque_${bloque.id}`} align="center">
                      {bloque.nota ?? 0}
                    </TableCell>
                  );
                })}
                <TableCell align="center">{el.definitiva}</TableCell>
                <TableCell align="center">
                  {asistencia.asisGeneral ?? 0}
                </TableCell>
                <TableCell align="center">
                  {asistencia.inasGeneral ?? 0}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={tabHanlder} aria-label="Boletín y Carreras">
          <Tab label="Boletín" {...a11yProps(0)} />
          <Tab label="Plan de evaluación" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={tab} p={0} index={0}>
        {boleta}
      </CustomTabPanel>
      <CustomTabPanel value={tab} index={1}>
        <PlanesEvaluacionesNotas
          type={2}
          materias={materias}
          planesEvaluacion={planEvaluacionStore.all}
          notasEvaluativas={data.notasEvaluativas}
          idDefinitiva
        />
      </CustomTabPanel>
    </Box>
  );
};

export default BoletinComponent;
